export default __webpack_public_path__ + "static/media/feature4.cc56ab1d.png";